// Dependencies
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import classNames from 'classnames';
import TimelineMax from 'gsap/TimelineMax';
import TweenLite from 'gsap/TweenLite';
import { Elastic, SlowMo, Power3 } from 'gsap/easing/EasePack';
import 'gsap/plugins/CSSPlugin';
import 'gsap/plugins/BezierPlugin';

// Components

// Actions

// Assets

function getRandom(min, max) {
  return Math.random() * (max - min) + min;
}

class Button extends Component {
  constructor() {
    super();

    this.particleCount = 0;
    this.particleCounter = undefined;
  }

  static defaultProps = {
    onClick: () => {}
  }

  handleClick = (e) => {
    const particles = [];
    this.props.onClick(e);

    const tl = new TimelineMax({
      // delay: 0.2,
      onComplete: () => {
        tl.kill();
      }
    });

    for (let i = 0; i < this.particleCount; i++) {
      particles.push(document.createElement('span'));
      ReactDOM.findDOMNode(this.button).appendChild(particles[i]);

      particles[i].classList.add(i % 2 ? 'left' : 'right');

      const dir = i % 2 ? '-' : '+';
      const r = i % 2 ? getRandom(-1, 1) * i / 2 : getRandom(-1, 1) * i;
      const size = i < 2 ? 1 : getRandom(0.2, 1);
      const initXPos = dir + getRandom(10, 80);
      const initYPos = getRandom(-80, 60);

      tl.set(particles[i], { scale: size });
      tl.to(particles[i], 1.6, {
        bezier: { // completely random settings, don't try to find a logic here
          // type: 'soft',
          curviness: 1,
          values: [
            { x: initXPos, y: initYPos },
            { x: initXPos * 1.3, y: initYPos + 20 },
            { x: initXPos * 1.6, y: initYPos + 30 }
          ]
        },
        scale: 0.2,
        ease: Power3.easeOut
      }, 0);
      tl.to(particles[i], getRandom(0.3, 0.8), {
        opacity: 0,
        ease: Power3.easeIn,
        onComplete: i => {
          particles[i].parentNode.removeChild(particles[i]);
        },
        onCompleteParams: [i]
      }, '-=1');
    }

    this.particleCount = 0;

    clearInterval(this.particleCounter);
  }

  handleMouseDown = () => {
    this.particleCount = 6;

    // The more you mouseDown, the more particles
    this.particleCounter = setInterval(() => {
      this.particleCount = Math.min(this.particleCount * 1.5, 30);
    }, 200);

    TweenLite.to(this.buttonBg, 0.6, { scale: 0.80, ease: SlowMo.ease.config(0.1, 0.9, false) });
  }

  handleMouseUp = () => {
    TweenLite.to(this.buttonBg, 0.6, { scale: 1.1, ease: Elastic.easeOut.config(1.2, 0.4) });
  }

  handleMouseOut = () => {
    TweenLite.to(this.buttonBg, 0.6, { scale: 1, ease: Elastic.easeOut.config(1.2, 0.4) });
  }

  render() {
    const { children, to, className, ...props } = this.props;

    return (
      <Link
        {...props}
        className={classNames('button button--snowball', className)}
        to={to}
        ref={ref => this.button = ref}
        onClick={this.handleClick}
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
        onMouseOver={this.handleMouseUp}
        onMouseOut={this.handleMouseOut}
      >
        {children}
        <span className="button__bg" ref={ref => this.buttonBg = ref} />
      </Link>
    );
  }
}

export default Button;



/** WEBPACK FOOTER **
 ** ./src/js/components/button.js
 **/